import fastdom from "fastdom";
import { type Ref, ref } from "vue";

let windowInnerWidth: Ref<number>;

fastdom.measure(() => {
    getWindowInnerWidth();
});

export function getWindowInnerWidth() {
    if (windowInnerWidth == undefined) {
        windowInnerWidth = ref(window.innerWidth);
        addEventListener(
            "resize",
            () => (windowInnerWidth.value = window.innerWidth)
        );
    }
    return windowInnerWidth;
}
